<template>

    <MenuSimple/>
    <HeadingForms/>

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="flex align-items-start p-4 bg-green-100 border-round border-1 border-green-300">
                        <i class="pi pi-check-circle text-green-900 text-2xl mr-3"></i>
                        <div class="mr-3">
                            <div class="text-green-900 font-medium text-xl mb-2 line-height-1">Success</div>
                            <p class="m-0 p-0 text-green-700 line-height-3">Your electronic form has been successfully
                                submitted. Please check your email for further information.</p>
                            <BR/>
                            <a class="font-medium text-yellow-900 hover:text-yellow-800 mr-4 no-underline cursor-pointer select-none transition-colors transition-duration-150"
                               @click="processHome">Go Back</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import MenuSimple from "@/components/menu/common/MenuSimple.vue";
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingForms from "@/components/heading/common/HeadingForms.vue";


export default {
    name: "FormSuccessful",
    components: {
        MenuSimple,
        HeadingForms,
        IsoEvolveFooter,
    },
    methods: {
        processHome() {
            window.location.href = "/#/login";
            window.location.reload();
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
